export const generalParams = {
  page: 0,
  size: 10,
  sort_dir: 'ASC',
  sort: 'id',
};
